export const styleCardNumber = {
  style: {
    fontWeight: 300,
    base: {
      fontSmoothing: "antialiased",
      fontFamily: "Rubik, sans-serif",
      fontSize: "17px",
      "::placeholder": {
        color: "#C0C0C0",
      },
      iconColor: "#C4C4C4",
    },
    invalid: {
      color: "#f56666",
      iconColor: "#f56666",
    },
  },
  placeholder: "",
  showIcon: true,
  iconStyle: "solid" as const,
};

export const styleCardExpiry = {
  style: {
    base: {
      fontSmoothing: "antialiased",
      fontFamily: "Rubik, sans-serif",
      fontSize: "17px",
      "::placeholder": {
        color: "#C0C0C0",
      },
    },
    invalid: {
      color: "#f56666",
    },
  },
};

export const styleCardCvc = {
  style: {
    base: {
      fontSmoothing: "antialiased",
      fontFamily: "Rubik, sans-serif",
      fontSize: "17px",
      "::placeholder": {
        color: "#C0C0C0",
      },
    },
    invalid: {
      color: "##f56666",
    },
  },
  placeholder: "",
};
